/** Admin guide §8 — Research settings (`admin/ResearchSettingsTab.tsx`, Settings → Research). */
import { helpSectionMeta } from '../help-sections.js';
import {
  Btn,
  Bullets,
  Callout,
  HelpSectionCard,
  Li,
  P,
  Screen,
  Shot,
  SubHead,
} from '../HelpPrimitives.js';

export function AdminResearchSettings(): React.JSX.Element {
  return (
    <HelpSectionCard meta={helpSectionMeta('admin-research-settings')}>
      <Shot
        slug="admin-research-settings"
        caption="Data-source strategy and review-gate mode for the Research section."
      />
      <P>
        Configures how the <Screen>Research</Screen> section finds and checks candidate companies.
        Nothing here fires an AI call by itself — it only changes what the Research screens do the
        next time someone uses them there.
      </P>

      <SubHead>Data-source strategy</SubHead>
      <Bullets>
        <Li>
          Click a strategy row to make it active: <Btn>ZoomInfo-first</Btn> (the current default) or{' '}
          <Btn>AI discovery → verification</Btn> as a fallback.
        </Li>
        <Li>
          <Btn>Apollo</Btn> and <Btn>Crunchbase</Btn> are shown but greyed out — not available yet,
          and rejected by the server if selected.
        </Li>
      </Bullets>

      <SubHead>Review-gate mode</SubHead>
      <P>
        Choose <Btn>Mandatory specialist review</Btn> (the default — every result needs a human
        accept/reject in Review before it can be published) or <Btn>Auto-deliver</Btn>.
      </P>

      <Callout title="Every strategy is web-search-free">
        <P>
          Whichever strategy is active, company verification always runs on text scraped from the
          company&rsquo;s own website — never Anthropic&rsquo;s web search tool. Switching
          strategies here changes how candidate companies are discovered, not that guarantee.
        </P>
      </Callout>
    </HelpSectionCard>
  );
}
